import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles((theme) => ({
  container: {
    paddingTop: 80,
    backgroundColor: theme.palette.primary.contrastText,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    [theme.breakpoints.up('md')]: {
      paddingTop: 120
    }
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%'
  },
  bodyContainer: {
    marginTop: theme.spacing(5),
    backgroundColor: theme.palette.background.alt,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(0, 2),
    [theme.breakpoints.up('lg')]: {
      padding: 0,
      width: 1260,
      margin: '20px auto'
    }
  },

  mainContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('lg')]: {
      flexDirection: 'row',
      alignItems: 'flex-start',
      justifyContent: 'space-between'
    }
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('lg')]: {
      width: 430,
      margin: '0 auto',
      minHeight: 450
    }
  },

  title: {
    fontSize: '1.375rem',
    lineHeight: '27px',
    fontWeight: 600,
    textAlign: 'center',
    margin: theme.spacing(6, 0)
  },
  label: {
    fontWeight: 500,
    fontSize: '0.75rem',
    [theme.breakpoints.up('lg')]: {
      fontSize: '0.875rem'
    }
  },
  description: {
    fontSize: '1.1rem',
    textAlign: 'center',
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(16)
  },

  inputTimePicker: {
    width: '40%',
    height: 40,
    minWidth: 120,
    '& > div > div': {
      marginLeft: 0
    },
    '& input': {
      fontSize: '0.85rem',
      height: 24,
      fontWeight: 500,
      backgroundColor: theme.palette.primary.contrastText,
      padding: theme.spacing(1.1, 1.8),
      [theme.breakpoints.up('md')]: {
        fontSize: '0.9rem'
      }
    },
    '& > div': {
      paddingRight: 0,
      height: 40
    },
    '& label': {
      color: theme.palette.primary.main,
      backgroundColor: theme.palette.primary.contrastText,
      fontWeight: 500,
      paddingRight: theme.spacing(),
      transform: 'translate(14px, 11px) scale(1)'
    },

    '& fieldset': {
      height: 45,
      borderColor: theme.palette.primary.main,
      borderRadius: 3
    },
    '&::placeholder': {
      color: 'rgba(105, 105, 105, 1)'
    },
    '& div > button': {
      width: 40,
      height: 40,
      borderRadius: 0,
      backgroundColor: theme.palette.primary.contrastText,
      color: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: theme.palette.primary.contrastText,
        color: theme.palette.primary.main
      }
    },

    [theme.breakpoints.up('sm')]: {
      width: 150
    }
  },

  inputDatePicker: {
    margin: 0,
    minWidth: 120,

    '& input': {
      height: 4,
      backgroundColor: theme.palette.primary.contrastText,
      fontWeight: 500,
      fontSize: '.9rem'
    },
    '& fieldset': {
      height: 45,
      padding: theme.spacing(1.1, 1.8),

      borderColor: theme.palette.primary.main,
      borderRadius: 3
    },
    '& svg': {
      color: theme.palette.primary.main
    },
    '& label': {
      color: theme.palette.primary.main,
      fontWeight: 500,
      transform: 'translate(14px, 11px) scale(1)',
      backgroundColor: theme.palette.primary.contrastText,
      paddingRight: theme.spacing(2.25)
    },
    '& > div > div': {
      marginLeft: 0
    },
    '& div > button': {
      width: 40,
      height: 40,
      borderRadius: 0,
      backgroundColor: theme.palette.primary.contrastText,
      color: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: theme.palette.primary.contrastText,
        color: theme.palette.primary.main
      }
    },
    '& > div': {
      paddingRight: 0,
      height: 40
    },
    [theme.breakpoints.up('sm')]: {
      width: 150
    }
  },
  input: {
    flexGrow: 1,
    '& fieldset': {
      backgroundColor: theme.palette.primary.contrastText,
      borderColor: theme.palette.primary.main,
      borderRadius: 3,
      minHeight: 45
    },

    [theme.breakpoints.up('md')]: {
      marginBottom: theme.spacing()
    },

    '& label': {
      color: theme.palette.primary.main,
      fontWeight: 500,
      backgroundColor: theme.palette.primary.contrastText,
      paddingRight: theme.spacing()
    },
    '& input': {
      zIndex: 1,
      fontWeight: 500
    },
    '& > p': {
      color: theme.palette.secondary.contrastText
    },

    '&.multiline': {
      '& textarea': {
        zIndex: 1,
        fontWeight: 500,
        '&::-webkit-scrollbar': {
          width: 12,
          [theme.breakpoints.up('md')]: {
            width: 16
          }
        },
        '&::-webkit-scrollbar-track': {
          boxShadow: 'inset 0 0 5px grey',
          borderRadius: 10,
          backgroundColor: theme.utils.rgba(theme.palette.primary.main, 0.2)
        },
        /* Handle */
        '&::-webkit-scrollbar-thumb': {
          borderRadius: 10,
          background: theme.utils.rgba(theme.palette.primary.main, 0.45)
        }
      }
    }
  },

  location: {
    display: 'flex',
    alignItems: 'center',

    height: '100%',
    width: '100%',
    '& input': {
      fontFamily: theme.typography.fontFamily,
      fontSize: '1rem',
      flexGrow: 1,
      width: '100%',
      height: 40,
      padding: theme.spacing(2),
      '&:focus': {
        outline: 'none'
      }
    },
    '&.disabled': {
      borderColor: '#696969'
    },
    '& button': {
      borderColor: theme.palette.primary.main,
      borderWidth: 1,
      borderRadius: '0px 5px 5px 0px',
      borderStyle: 'solid',
      borderLeft: 'none !important',
      height: 40,
      width: '100%',
      backgroundColor: theme.palette.primary.contrastText,
      '&:hover': {
        backgroundColor: theme.palette.primary.contrastText
      }
    }
  },
  formGroup: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: theme.spacing(2)
  },
  select: {
    height: 40,
    width: '100%',
    backgroundColor: theme.palette.primary.contrastText,
    '& > div': {
      padding: theme.spacing(1, 1.75),
      paddingTop: theme.spacing(0.5),
      fontWeight: 500
    },
    '& input': {
      height: 3,
      color: theme.palette.primary.main
    },
    '& fieldset': {
      height: 45,
      borderColor: theme.palette.primary.main,
      borderRadius: 5
    },
    '& svg': {
      color: theme.palette.primary.main,
      height: 19
    }
  },
  labelSelect: {
    color: theme.palette.primary.main,
    fontWeight: 500,
    paddingRight: theme.spacing(),
    backgroundColor: theme.palette.primary.contrastText,
    transform: 'translate(14px, 13px) scale(1)',
    '&.error': {
      color: '#f44336'
    }
  },
  disciplinesContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',

    '& > div': {
      width: '100%'
    },

    [theme.breakpoints.up('lg')]: {
      flexDirection: 'row'
    }
  },
  createButton: {
    width: 250,
    height: 48,
    alignSelf: 'center',
    marginTop: theme.spacing(2),
    borderRadius: 8,
    '& span': {
      fontSize: '1.125rem',
      fontWeight: 500
    }
  },
  errorMessage: {
    paddingLeft: theme.spacing(2)
  },

  datePickerContainer: {
    marginTop: theme.spacing(1.5)
  },
  datetimePickerContainer: {
    display: 'flex',
    gap: theme.spacing(3),
    justifyContent: 'space-between',
    height: 47
  },
  checkLabel: {
    fontSize: '.875rem'
  },
  checkMiniLabel: {
    fontSize: '.75rem'
  },
  checkbox: {
    '& svg': {
      color: theme.palette.primary.main
    }
  },
  formControl: {
    marginBottom: theme.spacing(3)
  },
  locationInput: {
    height: 40,
    '& input': {
      height: 7,
      zIndex: 1,
      fontWeight: 500,
      color: `${theme.palette.secondary.contrastText} !important`
    },
    '& fieldset': {
      borderColor: `${theme.palette.primary.main} !important`,
      height: 45,
      borderRight: 'none',
      borderRadius: '5px 0px 0px 5px',
      backgroundColor: theme.palette.primary.contrastText
    },
    '& label': {
      color: `${theme.palette.primary.main} !important`,
      fontWeight: 500,
      backgroundColor: theme.palette.primary.contrastText,
      paddingRight: theme.spacing()
    },
    '&.disabled': {
      '& fieldset': {
        borderColor: `${theme.palette.disabled.main} !important`
      },
      '& label': {
        color: `${theme.palette.disabled.main} !important`
      }
    }
  },
  dateEventContainer: {
    marginBottom: theme.spacing(3)
  },
  option: {
    zIndex: '2 !important',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontWeight: 500,
    color: theme.palette.secondary.contrastText,
    margin: theme.spacing(1, 0),
    marginRight: theme.spacing()
  },
  combo: {
    '& > div > label': {
      transform: 'translate(14px, 10px) scale(1)'
    },
    '& > div > div': {
      paddingBottom: `0 !important`,
      paddingTop: `0 !important`,
      paddingLeft: `${theme.spacing()} !important`,
      paddingRight: `${theme.spacing()} !important`
    },
    '& > div > div > div': {
      zIndex: 2
    },
    '& svg': {
      color: theme.palette.primary.main
    }
  },
  phoneForm: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('lg')]: {
      alignItems: 'flex-start',
      flexDirection: 'row'
    }
  },
  whatsAppContainer: {
    display: 'flex',
    alignItems: 'center',

    '& > span': {
      marginLeft: 0
    },

    [theme.breakpoints.up('lg')]: {
      marginRight: -theme.spacing(17),

      '& > span': {
        marginLeft: theme.spacing()
      }
    }
  },
  whatsAppTitle: {
    fontSize: '.875rem',
    flexShrink: 0,
    fontWeight: 600
  },
  infoButton: {
    alignSelf: 'flex-end',
    marginTop: -theme.spacing(2.5),
    marginBottom: theme.spacing(2),
    [theme.breakpoints.up('lg')]: {
      alignSelf: 'flex-start',
      marginTop: theme.spacing(),
      marginBottom: 0,
      marginRight: -theme.spacing(5)
    }
  },
  tooltipTitle: {
    fontSize: '.75rem'
  },
  tooltip: {
    backgroundColor: theme.palette.tooltip.main,
    width: 180,
    maxWidth: 180,
    padding: `${theme.spacing(1, 2)} !important`
  },
  tooltipButton: {
    right: '3px !important',
    top: '2px !important'
  },
  tooltipLink: {
    color: theme.palette.primary.contrastText
  },
  tooltipArrow: {
    color: theme.palette.tooltip.main
  }
}))

export default useStyles
